// The base no-unused-vars rule does not see type-only uses.
/* eslint no-unused-vars: "off", "@typescript-eslint/no-unused-vars": "warn" */
import React from 'react';
import { Header } from '@amzn/awsui-components-react-v3/polaris';
import ListTable, { ListColumn } from '../../Common/ListTable';
import { ARC_FILTERING_PLACEHOLDER, describeArc } from '../../../utils/arcRows';
import formatNumber from '../../../utils/formatNumber';
import { formatAmount } from '../ChangeSetImpact/changeSetImpact';
import { GoldenDatasetRow, WORD_COUNT_BANDS } from './goldenDatasets';

const COLUMNS: ListColumn<GoldenDatasetRow>[] = [
  { id: 'arc', header: 'Arc', cell: (row): string => describeArc(row.arc) },
  ...WORD_COUNT_BANDS.map(({ key, label }) => ({
    id: key,
    header: label,
    cell: (row: GoldenDatasetRow): string => formatNumber(row.wordCounts[key]),
  })),
  { id: 'totalWords', header: 'Total words', cell: (row): string => formatNumber(row.totalWords) },
  {
    id: 'goldenCost',
    header: 'Golden cost',
    cell: (row): string => formatAmount(row.goldenCost.amount, row.goldenCost.currency),
  },
];

/** A dataset's rows, read-only, in upload order, with a filter by arc. */
const GoldenDatasetRowsTable = ({ rows }: { rows: GoldenDatasetRow[] }): JSX.Element => (
  <ListTable
    id="goldenDatasetRows"
    items={rows}
    columns={COLUMNS}
    filterText={(row): string => describeArc(row.arc)}
    filteringPlaceholder={ARC_FILTERING_PLACEHOLDER}
    header={
      <Header variant="h2" counter={`(${rows.length})`}>
        Rows
      </Header>
    }
    empty="No rows yet; upload the template."
  />
);

export default GoldenDatasetRowsTable;
